var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comment",attrs:{"id":"comments"}})}
var staticRenderFns = []

export { render, staticRenderFns }